import { useSelector } from "react-redux";

const useSelectedDashboardFilters = () => {
  const selectedDevice = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedDevice
  );

  const selectedLocation = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedLocation
  );

  const selectedMarkets = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedMarket
  );

  const selectedPlatform = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedPlatform
  );

  const selectedBrowser = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedBrowser
  );

  const selectedAppType = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedAppType
  );

  const selectedGroup = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedGroup
  );

  const selectedConnectivity = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedConnectivity
  );

  const selectedPeriod = useSelector(
    (store) => store.dashboardFilters.selectedFilters.selectedPeriod
  );
  const fromDate = useSelector((store) => store.dashboardFilters.selectedFilters.selectedFromDate);
  const toDate = useSelector((store) => store.dashboardFilters.selectedFilters.selectedToDate);

  return {
    selectedDevice,
    selectedLocation,
    selectedMarkets,
    selectedPlatform,
    selectedBrowser,
    selectedAppType,
    selectedGroup,
    selectedConnectivity,
    selectedPeriod,
    fromDate,
    toDate
  };
};

export default useSelectedDashboardFilters;
